
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Boutique from "./pages/Boutique";
import Particulier from "./pages/Particulier";
import Professionnel from "./pages/Professionnel";
import SoinEnergetique from "./pages/SoinEnergetique";
import Hypnose from "./pages/Hypnose";
import Cercle from "./pages/Cercle";
import NettoyageLieux from "./pages/NettoyageLieux";
import CGV from "./pages/CGV";
import MentionsLegales from "./pages/MentionsLegales";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/boutique" element={<Boutique />} />
          <Route path="/particulier" element={<Particulier />} />
          <Route path="/professionnel" element={<Professionnel />} />
          <Route path="/soin-energetique" element={<SoinEnergetique />} />
          <Route path="/hypnose" element={<Hypnose />} />
          <Route path="/cercle" element={<Cercle />} />
          <Route path="/nettoyage-lieux" element={<NettoyageLieux />} />
          <Route path="/cgv" element={<CGV />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
